import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { useStyle as useAntdStyle } from '@ant-design/pro-utils';
import { useContext } from 'react';
import { ProLayoutContext } from '../../../context/ProLayoutContext';
import { genAppsLogoComponentsDefaultListStyle } from './default';
import { genAppsLogoComponentsSimpleListStyle } from './simple';

var genAppsLogoComponentsStyle = function genAppsLogoComponentsStyle(token) {
  var _popover;

  return _defineProperty({}, token.componentCls, {
    '&-icon': {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      paddingInline: 4,
      paddingBlock: 0,
      fontSize: 14,
      lineHeight: '14px',
      height: 28,
      width: 28,
      cursor: 'pointer',
      color: token.colorTextAppListIcon,
      '&:hover': {
        color: token.colorTextAppListIconHover,
        backgroundColor: token.colorBgAppListIconHover
      },
      '&-active': {
        color: token.colorTextAppListIconHover,
        backgroundColor: token.colorBgAppListIconHover
      }
    },
    '&-popover': (_popover = {}, _defineProperty(_popover, "".concat(token.antCls, "-popover-arrow"), {
      display: 'none'
    }), _defineProperty(_popover, '*', {
      boxSizing: 'border-box',
      fontFamily: token.fontFamily
    }), _popover),
    '&-simple': genAppsLogoComponentsSimpleListStyle(token),
    '&-default': genAppsLogoComponentsDefaultListStyle(token)
  });
};

export function useStyle(prefixCls) {
  var proToken = useContext(ProLayoutContext);
  return useAntdStyle('apps-logo-components', function (token) {
    var proCardToken = _objectSpread(_objectSpread({}, token), {}, {
      componentCls: ".".concat(prefixCls)
    }, proToken);

    return [genAppsLogoComponentsStyle(proCardToken)];
  });
}